<script lang="ts">
  // @ts-nocheck

  import { SortableList } from "@jhubbardsf/svelte-sortablejs";
  import closeIcon from "../assets/close.svg?raw";
  import d20SmallIcon from "../assets/d20-small.svg?raw";
  import underlineIcon from "../assets/underline.svg?raw";
  import {
    librarySoundSelected,
    libraryOpen,
    librarySounds,
    libraryScenes,
    librarySceneSelected,
    librarySearchIndex,
    windowHeight,
    windowWidth,
    isDarkTheme,
    userInfo,
    libraryTabSelected,
  } from "../store";
  import {
    showToastWrapper,
    SOUND_FROM_DRAWER_PREFIX,
    SCENE_FROM_DRAWER_PREFIX,
    MOBILE_SCREEN_WIDTH,
  } from "../global";
  import levenshtein from "js-levenshtein";
  import { flip } from "svelte/animate";
  import { blur, slide } from "svelte/transition";
  import LibrarySound from "./LibrarySound.svelte";
  import LibraryScene from "./LibraryScene.svelte";
  import LibrarySearch from "./search/LibrarySearch.svelte";
  import LibrarySoundUpload from "./LibrarySoundUpload.svelte";
  import LibraryPreviewPlayer from "./LibraryPreviewPlayer.svelte";
  import LibraryControls from "./LibraryControls.svelte";
  import { onMount } from "svelte";
  import {
    sortableForceFallbackForFirefox,
    sortablePreventDOMManipulation,
    sortablePreventDOMManipulationInLibrary,
  } from "../genericHandlers";
  import { v4 as uuidv4 } from "uuid";
  import LibrarySearchResults from "./LibrarySearchResults.svelte";
  import {
    libraryLayout,
    LibraryLayouts,
    isNewSound,
    libraryState,
    LibraryState,
  } from "./Library";
  import { LibrarySearchIndex } from "./search/LibrarySearch";
  import { notifyWhenMounted, tutorial } from "../tutorial/Tutorial";

  // These are arrays of PublicSound in library.go
  let soundsToShow = [];
  let scenesToShow = [];
  let showingScenes = false;

  function isUserSound(publicSound) {
    return publicSound.CreatedByUsername === $userInfo.username;
  }

  onMount(() => {
    fetch(`/app/library/all_sounds`)
      .then((response) => response.json())
      .then((data) => {
        librarySounds.init(
          data.map((elem, index) => {
            elem.LibraryIdx = index;
            return elem;
          }),
        );

        // // TODO BL: Let's not ship this yet.
        // librarySearchIndex.UpdateInPlace((index) => {
        //   index.loadRawSounds(data);
        // })

        soundsToShow = Array.from($librarySounds);
        soundsToShow.sort((a, b) => {
          return a.Name.localeCompare(b.Name);
        });
        handleSearchChanged(lastSearchedTerm, lastSearchedTags);
      })
      .catch((error) => {
        showToastWrapper("Error gathering library. please refresh.");
        console.error("Error gathering library. please refresh.", error);
      });

    fetch(`/app/library/all_scenes`)
      .then((response) => response.json())
      .then((data) => {
        const initialized = data.map((publicScene) => {
          publicScene.scene = JSON.parse(publicScene.Data);
          publicScene.scene.bannerUrl = publicScene.BannerUrl;
          return publicScene;
        });
        libraryScenes.set(new Map(initialized.map((pS) => [pS.Id, pS])));
        scenesToShow = initialized;
        handleSearchChanged(lastSearchedTerm, lastSearchedTags);
      })
      .catch((error) => {
        showToastWrapper("Error gathering library, please refresh.");
        console.error("Error gathering library. please refresh.", error);
      });
  });

  let tabs = [
    {
      name: "All",
      filter: (sound) => {
        return true;
      },
    },
    {
      name: "New",
      filter: (sound) => {
        return isNewSound(sound);
      },
    },
    {
      name: "Music",
      filter: (sound) => {
        return sound.Tags.includes("Music");
      },
    },
    {
      name: "Effects",
      filter: (sound) => {
        return sound.Tags.includes("Sound Effect");
      },
    },
    {
      name: "Ambiences",
      filter: (sound) => {
        return sound.Tags.includes("Ambience");
      },
    },
    {
      name: "My Sounds",
      filter: (sound) => {
        return isUserSound(sound);
      },
    },
    {
      name: "Scenes",
      filter: (elem) => {
        return true;
      },
    },
  ];

  const toggleLibrary = () => {
    if ($libraryState === LibraryState.Closed) {
      libraryState.set(LibraryState.Opening);
    } else if ($libraryState === LibraryState.Opening) {
      // Do nothing, let it open.
    } else {
      libraryState.set(LibraryState.Closed);
      handleSearchChanged("", []);
    }
  };

  const handleOnChooseSound = (evt) => {
    const soundIdx = evt.item.id.replace(SOUND_FROM_DRAWER_PREFIX, "");
    const sound = soundsToShow[soundIdx];
    librarySoundSelected.set(sound);
  };
  const handleOnUnchooseSound = (evt) => {
    librarySoundSelected.set(null);
    sortablePreventDOMManipulationInLibrary(evt);
  };

  const handleOnChooseScene = (evt) => {
    const sceneId = evt.item.id.replace(SCENE_FROM_DRAWER_PREFIX, "");
    let scene = $libraryScenes.get(sceneId);
    librarySceneSelected.set(scene);
  };
  const handleOnUnchooseScene = (evt) => {
    librarySceneSelected.set(null);
    sortablePreventDOMManipulationInLibrary(evt);
  };

  const hasTagThatMatches = (publicSound, term) => {
    return (
      publicSound.Tags.find((tag) => tag.toLowerCase().includes(term)) !==
      undefined
    );
  };

  const searchBarSort = (searched, a, b) => {
    // const isNewA = isNewSound(a);
    // const isNewB = isNewSound(b);
    // if (isNewA && !isNewB) {
    //   return -1;
    // } else if (!isNewA && isNewB) {
    //   return 1;
    // }

    const searchTerm = searched.toLowerCase();
    const aName = a.Name.toLowerCase();
    const bName = b.Name.toLowerCase();
    if (searched === "") {
      // Shortcut sorting if there is no search term
      return aName.localeCompare(bName);
    }
    const isPartOfAsName = aName.includes(searchTerm);
    const isPartOfBsName = bName.includes(searchTerm);
    if (isPartOfAsName && !isPartOfBsName) {
      return -1;
    } else if (!isPartOfAsName && isPartOfBsName) {
      return 1;
    }

    // It is either part of both, or part of neither. In any case, Levenshtein
    // to disambiguate.
    const distToA = levenshtein(searchTerm, aName);
    const distToB = levenshtein(searchTerm, bName);
    if (distToA !== distToB) {
      return distToA - distToB;
    }
    // If they have the same Levenshtein distance, just sort alphabetically
    return aName.localeCompare(bName);
  };

  const searchBarFilter = (elem, tagsSearched) => {
    for (let i = 0; i < tagsSearched.length; i++) {
      let tag = tagsSearched[i];
      if (!hasTagThatMatches(elem, tag)) {
        return false;
      }
    }
    return true;
  };

  let lastSearchedTerm = "";
  let lastSearchedTags = [];
  const handleSearchChanged = (content, tagsSearched) => {
    lastSearchedTerm = content;
    lastSearchedTags = [];
    for (let i = 0; i < tagsSearched.length; i++) {
      lastSearchedTags[i] = tagsSearched[i].toLowerCase();
    }

    if (showingScenes) {
      scenesToShow = Array.from(
        $libraryScenes
          .values()
          .filter(tabs[activeTab].filter)
          .filter((a) => searchBarFilter(a, lastSearchedTags)),
      );
      scenesToShow.sort((a, b) => searchBarSort(content, a, b));
      scenesToShow = scenesToShow;
    } else {
      soundsToShow = $librarySounds
        .filter(tabs[activeTab].filter)
        .filter((a) => searchBarFilter(a, lastSearchedTags));
      soundsToShow.sort((a, b) => searchBarSort(content, a, b));
      soundsToShow = soundsToShow;
    }
    tutorial.notifySearchChanged();
  };

  let activeTab = 0;
  let scenesIdx = 6;
  const handleTabSelected = (idx) => {
    activeTab = idx;
    if (idx === scenesIdx) {
      showingScenes = true;
    } else {
      showingScenes = false;
    }
    handleSearchChanged(lastSearchedTerm, lastSearchedTags);
    libraryTabSelected.set(idx);
  };

  let previewPlayer;
  let currentLibrarySoundStopFn = null;
  const handleSoundPlay = (stopSoundFn, publicSound) => {
    stopCurrentSound();
    previewPlayer.playSound(publicSound);
    currentLibrarySoundStopFn = stopSoundFn;
  };

  function stopCurrentSound() {
    if (currentLibrarySoundStopFn !== null) {
      currentLibrarySoundStopFn();
    }
  }

  const handleSoundStop = () => {
    previewPlayer.stopSound();
    stopCurrentSound();
  };

  librarySounds.subscribe((sounds) => {
    handleSearchChanged(lastSearchedTerm, lastSearchedTags);
  });

  function handleNewSoundUploaded(publicSound) {
    librarySounds.update((sounds) => {
      publicSound.LibraryIdx = sounds.length;
      sounds.push(publicSound);
      return sounds;
    });
  }

  function handleSoundChanged(idx: number, updatedPublicSound) {
    librarySounds.update((sounds) => {
      sounds[updatedPublicSound.LibraryIdx] = updatedPublicSound;
      return sounds;
    });
  }
</script>

{#if $libraryState !== LibraryState.Closed}
  <article
    id="library"
    class="library border-pico-color"
    in:slide={{ duration: 100 }}
    out:slide={{ duration: 100 }}
    on:introend={() => {
      libraryState.set(LibraryState.Open);
    }}
    use:notifyWhenMounted
    class:library-right={$libraryLayout === LibraryLayouts.DockedRight}
    class:library-bottom={$libraryLayout === LibraryLayouts.DockedBottom}
    class:library-mobile={$libraryLayout === LibraryLayouts.Mobile}
    class:glow={$isDarkTheme}
    class:dark-glow={$isDarkTheme}
    class:light-glow={!$isDarkTheme}
    class:border-bardic-light={$isDarkTheme}
  >
    <div class="title">
      <div class="center-contents-h margin-bottom-0">
        <h3 class="margin-bottom-0">The Library</h3>
        <div class="container-small height-1rem width-10rem margin-bottom-0">
          {@html underlineIcon}
        </div>
      </div>
    </div>
    <LibraryControls />
    <div class="quick-filters font-family-bardic-sans">
      {#each tabs as tab, i (tab.name)}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <!-- svelte-ignore a11y-missing-attribute -->
        <div
          class="quick-filter"
          id="quick-filter-{tab.name}"
          class:active={i === activeTab}
          aria-label="make tab {i} active"
          on:click={() => handleTabSelected(i)}
        >
          {#if $libraryLayout === LibraryLayouts.DockedBottom}
            <div class="width-1rem">
              {@html d20SmallIcon}
            </div>
          {/if}
          {tab.name}
        </div>
      {/each}
    </div>
    <div class="search">
      <LibrarySearch {handleSearchChanged} />
    </div>
    <div class="chooser" id="library-search-results">
      <!-- Chooser -->
      <LibrarySearchResults
        {scenesToShow}
        {soundsToShow}
        {showingScenes}
        {handleOnChooseScene}
        {handleOnUnchooseScene}
        {handleOnChooseSound}
        {handleOnUnchooseSound}
        {handleSoundPlay}
        {handleSoundStop}
        {handleSoundChanged}
      />
    </div>
    {#if !showingScenes || $libraryLayout === LibraryLayouts.DockedBottom}
      <div class="previewer">
        <LibraryPreviewPlayer
          bind:this={previewPlayer}
          onSoundStop={stopCurrentSound}
        />
      </div>
    {/if}
    <div class="upload">
      <LibrarySoundUpload newSoundUploadedCallback={handleNewSoundUploaded} />
    </div>
    <div class="instructions font-size-0-7rem">
      <small class="center-contents-h"
        >Drag items to add them to your board.</small
      >
    </div>
  </article>
{/if}

<button
  id="library-button"
  class="library-button"
  class:open={$libraryState !== LibraryState.Closed}
  class:closed={$libraryState === LibraryState.Closed}
  on:click={toggleLibrary}
  data-tooltip={$libraryState !== LibraryState.Closed
    ? null
    : "300+ sounds available!"}
>
  {#if $libraryState === LibraryState.Closed}
    Search The Library
  {/if}
  <span
    class="library-button-icon"
    class:open={$libraryState !== LibraryState.Closed}
    class:closed={$libraryState === LibraryState.Closed}>{@html closeIcon}</span
  >
</button>
